<template>
  <section>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <button class="button" @click="init">Refresh</button>
          <b-input placeholder="Search..." v-model="search_query" type="search" icon="search" icon-pack="fas" width="250"></b-input>
        </div>
      </div>
      <div class="level-center">
        <div class="level-item">
            
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-success is-pulled-right" :to="supId ? ('/product/add/'+supId):'/product/add/'" v-can="'add_product'"><i class="fas fa-plus"></i>เพิ่มผลิตภัณฑ์</router-link>
          </div>
        </div>
      </div>
    </nav>

    
    <div class="product_table">
      <b-table
        :data="filteredData"
        selectable @click="selected"
        :selected.sync="selectedItem"
        :hoverable="true"
        :loading="isTableLoading"

        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        @page-change="onPageChange"
        :narrowed="true"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="ID" width="40" numeric>
              {{ props.row.id }}
          </b-table-column>

          <b-table-column field="name" label="ชื่อผลิตภัณฑ์">
              {{ props.row.name }}
          </b-table-column>

          <b-table-column field="sup_name" label="ซัพพลายเออร์">
              {{ props.row.sup_name }}
          </b-table-column>

          <b-table-column field="price_buy" label="ราคาชื้อ">
              {{ props.row.price_buy }} บาท/{{ props.row.unit_buy_text }}
          </b-table-column>

          <b-table-column field="price_sell" label="ราคาขาย">
              {{ props.row.price_sell }} บาท/{{ props.row.unit_sell_text }}
          </b-table-column>
        </template>
      </b-table>
      <div class="notification has-text-centered" v-if="all_product.length == 0 && !isTableLoading">ไม่พบข้อมูล</div>
    </div>
  </section>
</template>

<script>
  import ProductModel from '@/model/product_model'
  import Request from '@/libraries/request'
  import Const from '@/const/const'

  export default {
    name: 'Product',
    props: ['supId'],
    data() {
      return {
        all_product: [],
        selectedItem: {},
        lastSelected: {},
        isTableLoading: true,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.all_product.filter(product => {
          return (
                  (product.name && product.name.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (product.sup_name && product.sup_name.toLowerCase().includes(this.search_query.toLowerCase()))

                )
        })
      }
    },
    methods: {
      async init(){
        this.all_product = await ProductModel.get_all_product(this.supId);
        this.isTableLoading = false;
      },
      selected(item) {
        if(!this.can("edit_product|add_product")){
          this.$buefy.toast.open('คุณไม่มีสิทธิ์ที่จะเข้าถึงส่วนนี้!');
          return;
        }
        if(this.lastSelected == item){
          this.$router.push({ path: '/product/edit/'+item.id })
        }
        this.lastSelected = item;
      },
      onPageChange(page){
        if(!this.supId){
          this.scrollTo({ 
            to: 'body'
          });
        }else{
          this.scrollTo({ 
            to: '.product_table'
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Product_list.vue